import {Rate} from 'antd';


const successStoriesData = [
  {
    bodyText: "Critical Finance is a leading financial services provider that has transformed its operations with our platform. By leveraging advanced analytics and real-time data, they have improved decision-making and enhanced customer satisfaction.",
    personText: "John Doe, CFO of Critical Finance",
    starRating: 4.5
  },
  {
    bodyText: "Global Tech Solutions, a multinational technology company, has streamlined its financial processes using our innovative tools, resulting in significant cost savings and increased efficiency across its global operations.",
    personText: "Jane Smith, COO of Global Tech Solutions",
    starRating: 5
  },
  {
    bodyText: "EcoFinance, a sustainable finance organization, has utilized our platform to better manage their investments in green projects, contributing to a more sustainable future while achieving strong financial returns.",
    personText: "Alice Johnson, CEO of EcoFinance",
    starRating: 4
  }
];

function SuccessStoryCard({ bodyText, personText, starRating }) {
  return (
    <div className="success-story-card">
      <p>{bodyText}</p>
      <h3>{personText}</h3>
      <Rate allowHalf defaultValue={starRating} />
    </div>
  );
}

function SuccessStories() {
  return (
    <div className="success-stories">
      <div className="success-stories-banner">
        <h2 className="success-stories-header">Success Stories from our Users</h2>
        <p className="success-stories-subtitle">Hear what they have to say</p>
      </div>
      <div className="success-stories-container">
        {successStoriesData.map((story, index) => (
          <SuccessStoryCard key={index} {...story} />
        ))}
      </div>
    </div>
  );
}

export default SuccessStories;